import { render, staticRenderFns } from "./OrderListMobile.vue?vue&type=template&id=57289d6b"
import script from "./OrderListMobile.vue?vue&type=script&lang=js"
export * from "./OrderListMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports